<template>
  <div class="checkout-container">
    <!-- Colonne principale -->
    <div class="main-column">
      <h1 class="checkout-title">COMMANDER</h1>

      <!-- Adresse de livraison -->
      <div class="section">
        <h2 class="section-title">ADRESSE DE LIVRAISON</h2>

        <div v-for="address in addresses" :key="address.id" class="address-card">
          <input
            type="radio"
            :value="address.id"
            v-model="selectedAddressId"
            @change="selectAddress(address.id)"
          />
          <div class="address-details">
            <p v-if="address.company && address.company !== 'Non spécifié'">{{ address.company }}</p>
            <p>{{ address.prefix }} {{ address.firstName }} {{ address.lastName }}</p>
            <p>{{ address.address }}</p>
            <p>{{ address.city }}, {{ address.postalCode }}</p>
            <p>{{ address.country }}</p>
            <p>{{ address.phoneNumber }}</p>
            <p>{{ address.vatNumber }}</p>
          </div>

          <div class="address-actions">
            <button @click="confirmDeleteAddress(address.id)" class="icon-btn delete-btn" title="Supprimer">
              <i class="fas fa-trash-alt"></i>
            </button>
            <button @click="editAddress(address.id)" class="icon-btn edit-btn" title="Modifier">
              <i class="fas fa-edit"></i>
            </button>
          </div>
        </div>

        <button class="new-address-btn" @click="openFormPopup">+ Nouvelle adresse</button>
      </div>

      <!-- Boîte de confirmation de suppression -->
      <div v-if="showDeleteConfirmation" class="confirmation-overlay">
        <div class="confirmation-box">
          <p>Êtes-vous sûr de vouloir supprimer cette adresse ?</p>
          <button @click="deleteAddress" class="confirm-btn">Oui</button>
          <button @click="cancelDelete" class="cancel-btn">Non</button>
        </div>
      </div>

      <!-- Nouvelle Adresse Form Popup -->
      <div v-if="showFormPopup" class="popup-overlay">
        <div class="popup-content">
          <h2>ADRESSE DE LIVRAISON</h2>
          <form @submit.prevent="submitForm" class="scrollable-form">
          <!--  <label>Préfixe de nom *</label>
            <select v-model="newAddress.prefix" required>
              <option>Monsieur</option>
              <option>Madame</option>
            </select>

            <label>Prénom *</label>
            <input type="text" v-model="newAddress.firstName" required />

            <label>Nom *</label>
            <input type="text" v-model="newAddress.lastName" required />

            <label>Société</label>
            <input type="text" v-model="newAddress.company" /> -->

            <label>Adresse *</label>
            <input type="text" v-model="newAddress.address" required />

            <label>Pays *</label>
            <select id="pays" v-model="newAddress.country" required>
              <option value="">Sélectionnez un pays</option>
              <option v-for="country in countries" :key="country" :value="country">
                {{ country }}
              </option>
            </select>

            <label>Ville *</label>
            <input type="text" v-model="newAddress.city" required />

            <label>Code postal *</label>
            <input type="text" v-model="newAddress.postalCode" required />

            <label>Numéro de téléphone *</label>
            <input type="text" v-model="newAddress.phoneNumber" required />

            <div class="form-buttons">
              <button type="submit" class="submit-btn">Enregistrer</button>
              <button type="button" @click="closeFormPopup" class="cancel-btn">Annuler</button>
            </div>
          </form>
        </div>
      </div>

      <!-- Modes de livraison -->
      <div class="section">
        <h2 class="section-title">MODES DE LIVRAISON</h2>
        <table class="delivery-table">
          <tbody>
            <tr>
              <td>
                <!--  v-model + value -->
                <input type="radio" name="shipping" value="supracare_48h" v-model="selectedShipping" />
              </td>
              <td>Livraison Supracare</td>
              <td>48h</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Bouton suivant -->
      <div class="next-button-container">
           <button @click="goBack" class="back-btn">Retour</button>
        <button class="next-btn" @click="goToPayment">Suivant</button>
      </div>
    </div>

    <!-- Colonne de résumé de la commande -->
    <div class="summary-column">
      <h2>RÉSUMÉ DE LA COMMANDE</h2>
      <div v-if="items && items.length" class="summary-content">
        <div v-for="item in items" :key="item.id" class="item">
          <img :src="item.image" :alt="item.name" class="item-img" />
          <div class="item-details">
            <p>{{ item.name }} (Qté: {{ item.quantity }})</p>
            <p>{{ (item.price * item.quantity).toFixed(2) }} MAD</p>
          </div>
        </div>
        <div class="total">
          <p>Sous-total : {{ totalPrice.toFixed(2) }} MAD</p>
          <p><strong>Total TTC : {{ totalPrice.toFixed(2) }} MAD</strong></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShippingPage",
  data() {
    return {
      items: [],
      addresses: [],
      selectedAddress: null,
      selectedAddressId: null,
      selectedShipping: null, // on l’utilise avec v-model
      countries: [],
      totalPrice: 0,

      // popups / edition
      showFormPopup: false,
      showDeleteConfirmation: false,
      showEditForm: false,
      addressToDelete: null,
      addressToEdit: null,

      newAddress: {
        prefix: "Monsieur",
        firstName: "",
        lastName: "",
        company: "",
        address: "",
        country: "",
        city: "",
        postalCode: "",
        phoneNumber: "",
        vatNumber: "",
      },
    };
  },

  mounted() {
    // Vérif auth en sessionStorage
    const isAuthenticated = sessionStorage.getItem("isAuthenticated");
    const userString = sessionStorage.getItem("user");

    if (isAuthenticated !== "true") {
      // stocker la destination dans sessionStorage (cohérent)
      sessionStorage.setItem("redirectAfterLogin", "/shipping");
      this.$router.push("/connexion");
      return;
    }

    this.fetchCountries();

    // Injecter l'adresse de l'utilisateur connecté
    if (userString) {
      const user = JSON.parse(userString);
      const userAddress = {
        id: 9999,
        prefix: user.civilite || "Monsieur",
        firstName: user.prenom || "",
        lastName: user.nom || "",
        company: user.societe || "",
        address: user.adresse || "",
        city: user.ville || "",
        postalCode: user.codePostal || "",
        country: user.pays || "",
        phoneNumber: user.telephone || "",
        vatNumber: user.vatNumber || "",
      };

      this.addresses = [userAddress];
      this.selectedAddressId = userAddress.id;

      // On persiste les adresses/choix côté client
      localStorage.setItem("addresses", JSON.stringify(this.addresses));
      localStorage.setItem("selectedAddressId", String(userAddress.id));
    }

    this.loadSelectedData();
  },

  methods: {
    loadSelectedData() {
      // Adresses/choix persistés côté client (localStorage OK)
      const addresses = JSON.parse(localStorage.getItem("addresses") || "[]");
      const selectedAddressIdStr = localStorage.getItem("selectedAddressId");
      const selectedShipping = localStorage.getItem("selectedShipping");

      //Panier depuis sessionStorage (cohérent avec Panier)
      const items = JSON.parse(sessionStorage.getItem("cart") || "[]");

      if (addresses.length) this.addresses = addresses;
      if (selectedAddressIdStr) {
        const id = parseInt(selectedAddressIdStr, 10);
        this.selectedAddressId = isNaN(id) ? null : id;
        this.selectedAddress = this.addresses.find((a) => a.id === this.selectedAddressId) || null;
      }
      if (selectedShipping) this.selectedShipping = selectedShipping;

      this.items = items;
      this.totalPrice = this.items.reduce((t, it) => t + it.price * it.quantity, 0);
    },

    goBack() {
      this.$router.push("/shop");
    },

 async fetchCountries() {
  try {
    const res = await fetch(
      'https://restcountries.com/v3.1/all?fields=name,cca2,translations'
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();

    this.countries = data
      .map(c => c?.translations?.fra?.common ?? c?.name?.common ?? '')
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
  } catch (e) {
    console.error('Erreur lors de la récupération des pays :', e);
  }
},

    openFormPopup() {
      this.showFormPopup = true;
    },
    closeFormPopup() {
      this.showFormPopup = false;
      this.showEditForm = false;
      this.resetForm();
    },

    submitForm() {
      if (this.showEditForm && this.addressToEdit !== null) {
        const index = this.addresses.findIndex((a) => a.id === this.addressToEdit);
        if (index !== -1) {
          this.addresses[index] = { ...this.newAddress, id: this.addressToEdit };
        }
      } else {
        const newId = this.addresses.length ? this.addresses[this.addresses.length - 1].id + 1 : 1;
        const newAddressCopy = { ...this.newAddress, id: newId };
        this.addresses.push(newAddressCopy);
      }

      this.saveAddressesToLocalStorage();
      this.resetForm();
      this.closeFormPopup();
    },

    resetForm() {
      this.newAddress = {
        prefix: "Monsieur",
        firstName: "",
        lastName: "",
        company: "",
        address: "",
        country: "",
        city: "",
        postalCode: "",
        phoneNumber: "",
        vatNumber: "",
      };
      this.addressToEdit = null;
    },

    saveAddressesToLocalStorage() {
      localStorage.setItem("addresses", JSON.stringify(this.addresses));
      if (this.selectedAddressId != null) {
        localStorage.setItem("selectedAddressId", String(this.selectedAddressId));
      }
    },

    loadAddressesFromLocalStorage() {
      const storedAddresses = localStorage.getItem("addresses");
      const storedSelectedAddress = localStorage.getItem("selectedAddressId");

      if (storedAddresses) {
        this.addresses = JSON.parse(storedAddresses);
      } else {
        this.addresses = [
          {
            id: 1,
            prefix: "Monsieur",
            firstName: "BRAHIM",
            lastName: "SOBAI",
            company: "cmm",
            address: "CASABLANCA, 209000",
            country: "Maroc",
            city: "CASABLANCA",
            postalCode: "209000",
            phoneNumber: "0667791380",
            vatNumber: "DE123456789",
          },
        ];
      }

      if (storedSelectedAddress) {
        this.selectedAddressId = parseInt(storedSelectedAddress, 10);
      }
    },

    selectAddress(id) {
      this.selectedAddressId = id;
      this.saveAddressesToLocalStorage();
    },

    confirmDeleteAddress(id) {
      this.addressToDelete = id;
      this.showDeleteConfirmation = true;
    },
    deleteAddress() {
      this.addresses = this.addresses.filter((a) => a.id !== this.addressToDelete);
      this.addressToDelete = null;
      this.showDeleteConfirmation = false;
      this.saveAddressesToLocalStorage();
    },
    cancelDelete() {
      this.addressToDelete = null;
      this.showDeleteConfirmation = false;
    },

    editAddress(id) {
      this.showEditForm = true;
      this.addressToEdit = id;
      const address = this.addresses.find((a) => a.id === id);
      if (address) {
        this.newAddress = { ...address };
        this.openFormPopup();
      }
    },

    goToPayment() {
      const isAuthenticated = sessionStorage.getItem("isAuthenticated") === "true";

      if (!this.selectedAddressId) {
        alert("Veuillez sélectionner une adresse de livraison avant de continuer.");
        return;
      }
      if (!this.selectedShipping) {
        alert("Veuillez sélectionner un mode de livraison avant de continuer.");
        return;
      }

      // Persister les choix côté client (items sont déjà dans sessionStorage 'cart')
      localStorage.setItem("selectedAddressId", String(this.selectedAddressId));
      localStorage.setItem("selectedShipping", this.selectedShipping);

      if (isAuthenticated) {
        this.$router.push("/payment");
      } else {
        sessionStorage.setItem("redirectAfterLogin", "/payment");
        this.$router.push("/connexion");
      }
    },
  },
};
</script>

<style scoped>
/* ====== MODE CLAIR (par défaut) ====== */
.checkout-container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background-color: #f4f4f4;
}
.main-column,
.summary-column {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.main-column { width: 65%; }
.summary-column { width: 30%; }

.checkout-title { font-size: 2rem; margin-bottom: 1rem; color: #222; }
.section-title, .summary-title { font-size: 1rem; margin-bottom: 1rem; color: #444; }
.section { margin-bottom: 20px; }

/* ====== ADRESSES ====== */
.address-card {
  border: 1px solid #ddd;
  padding: 15px;
  margin-bottom: 10px;
  position: relative;
  background-color: #fff;
}
.address-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 10px;
}
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #555;
  transition: color 0.2s;
}
.icon-btn:hover { color: #e74c3c; }
.edit-btn:hover { color: #3498db; }
.address-details { margin-left: 10px; }

.new-address-btn {
  background-color: #cbcfd4;
  color: #383737;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.new-address-btn:hover { background-color: #004a99; }

.delete-btn {
  background-color: #7a7878;
  color: #fff;
  padding: 5px 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
  margin-right: 1rem;
}
.delete-btn:hover { background-color: #c82333; }

.edit-btn {
  background-color: #6c6e6f;
  color: #fff;
  padding: 5px 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}
.edit-btn:hover { background-color: #0056b3; }

/* ====== CONFIRMATION SUPPRESSION ====== */
.confirmation-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.confirmation-box {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  width: 300px;
}
.confirm-btn, .cancel-btn {
  margin: 10px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.confirm-btn { background-color: #dc3545; color: #fff; }
.cancel-btn  { background-color: #6c757d; color: #fff; }

/* ====== LIVRAISON (TABLE) ====== */
.delivery-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.delivery-table th,
.delivery-table td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

/* ====== BOUTONS NEXT / BACK / CONFIRM ====== */
.next-button-container,
.actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  margin-top: 10px;
}
.back-btn,
.confirm-btn,
.next-btn {
  min-width: 180px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  font-weight: 600;
  line-height: 1;
}
.back-btn { background-color: #6c757d; color: #fff; }
.next-btn,
.confirm-btn { background-color: #078679; color: #fff; }
.next-btn:hover,
.confirm-btn:hover { background-color: #218838; }

/* ====== RÉSUMÉ & ITEMS ====== */
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}
.item-img {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
}
.item-details {
  flex-grow: 1;
  margin-left: 10px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.total {
  border-top: 1px solid #ddd;
  padding-top: 10px;
}

/* ====== POPUP ADRESSE ====== */
.popup-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-content {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 500px;
  max-width: 90%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}
.scrollable-form {
  overflow-y: auto;
  padding-right: 10px;
  max-height: 60vh;
}
.popup-content h2 { margin-bottom: 20px; font-size: 1.5rem; }
.popup-content label {
  display: block;
  margin-top: 10px;
  margin-bottom: 5px;
}
.popup-content input,
.popup-content select {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.form-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.submit-btn {
  background-color: #28a745;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.submit-btn:hover { background-color: #218838; }
.cancel-btn:hover { background-color: #c82333; }

/* ====== PAYMENT LAYOUT ====== */
.payment-page-container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.main-column { width: 65%; }
.summary-column { width: 30%; }

/* ====== RESPONSIVE ====== */
@media (max-width: 1024px) {
  .checkout-container,
  .payment-page-container {
    flex-direction: column;
    padding: 15px;
  }
  .main-column,
  .summary-column {
    width: 100% !important;
    margin-bottom: 20px;
  }
  .next-button-container,
  .actions { justify-content: center; }
  .next-btn { width: 100%; padding: 12px; font-size: 16px; }
  .address-actions {
    position: static;
    margin-top: 10px;
    justify-content: flex-end;
  }
}
@media (max-width: 600px) {
  .next-button-container,
  .actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .back-btn,
  .confirm-btn,
  .next-btn {
    width: 100%;
    min-width: 0;
  }
}
@media (max-width: 450px) {
  .checkout-container,
  .payment-page-container { padding: 10px; }
  .main-column,
  .summary-column { padding: 15px; }
  .checkout-title { font-size: 1.5rem; text-align: center; }
  .section-title, .summary-title { font-size: 1rem; text-align: center; }
  .item { flex-direction: column; align-items: flex-start; }
  .item-details { margin-left: 0; width: 100%; text-align: left; }
  .item-img { margin-bottom: 10px; }
  .popup-content { width: 90%; padding: 20px; }
  .popup-content h2 { font-size: 1.25rem; }
  .popup-content input, .popup-content select { font-size: 14px; }
  .form-buttons { flex-direction: column; gap: 10px; }
  .delete-btn, .edit-btn { width: 100%; margin-right: 0; }
}

/* ====== MODE SOMBRE AUTOMATIQUE ====== */
@media (prefers-color-scheme: dark) {
  .checkout-container,
  .payment-page-container {
    background-color: #121212;
  }
  .main-column,
  .summary-column {
    background-color: #1e1e1e;
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.05);
    color: #f1f1f1;
  }
  .checkout-title,
  .section-title,
  .summary-title {
    color: #f5f5f5;
  }
  .address-card {
    background-color: #1f1f1f;
    border-color: #333;
    color: #e0e0e0;
  }
  .icon-btn { color: #bbb; }
  .icon-btn:hover { color: #ff6666; }
  .edit-btn:hover { color: #66b3ff; }
  .new-address-btn {
    background-color: #333;
    color: #fff;
  }
  .new-address-btn:hover { background-color: #078679; }
  .delete-btn {
    background-color: #444;
  }
  .delete-btn:hover { background-color: #c82333; }
  .edit-btn {
    background-color: #333;
  }
  .edit-btn:hover { background-color: #078679; }

  .confirmation-box {
    background-color: #1e1e1e;
    color: #fff;
  }
  .confirm-btn { background-color: #c82333; }
  .cancel-btn { background-color: #555; }

  .delivery-table th,
  .delivery-table td {
    border-bottom: 1px solid #333;
    color: #ddd;
  }

  .back-btn { background-color: #555; color: #fff; }
  .next-btn,
  .confirm-btn { background-color: #078679; color: #fff; }
  .next-btn:hover,
  .confirm-btn:hover { background-color: #219a8a; }

  .item {
    border-bottom: 1px solid #333;
  }
  .total {
    border-top: 1px solid #333;
  }

  .popup-content {
    background-color: #1e1e1e;
    color: #f1f1f1;
  }
  .popup-content input,
  .popup-content select {
    background-color: #2a2a2a;
    border-color: #444;
    color: #fff;
  }
  .submit-btn {
    background-color: #078679;
  }
  .submit-btn:hover {
    background-color: #219a8a;
  }
}
</style>
